export const HORN_KEY = 'sailor_b_pc_config'

export const defaultHornConfig = {
  // 数据上报错误重试间隔配置
  retryConfig: {
    needRetry: true,
    retryArr: [2, 4, 8, 8, 8],
  },
  // OM升级提醒弹窗配置
  updateNotificationConfig: {
    needNotificate: false,
    lowestVersion: '0.0.0', // 最低版本号，如果当前版本号小于最低版本号，则不通知
  },
  // 无声音权限时弹窗课程id映射表
  noSoundPermissionCourseIdMapping: {
    QA: 18,
    KW: 47,
    AE: 55,
    BH: 136,
  },
  // 需要自动上传logan日志的shopId
  autoUploadLog: [],
  // 无心跳置休 - 系统资源判断条件
  offlineSystemResourceConfig: [
    {
      sourceType: 'cpu', // 资源类型 cpu | memory
      calcType: 3, // 0: 平均值 1: tp50 2: tp75 3: tp90
      threshold: 80, // 阈值
    },
    {
      sourceType: 'memory',
      calcType: 3,
      threshold: 80,
    },
  ],
  printConfig: {
    mode: 'none',
    gray: 0,
    templatePeloadGray: 0,
    imgV2Gray: 0,
  },
}
